var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-page"},[_c('div',{staticClass:"content-container"},[_c('taminotchi-form',{attrs:{"datas":_vm.dataall}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }